import { cn } from '@/shared/utils';

const ScorePill = ({ value, highlight }) => (
  <span
    className={cn(
      'min-w-[32px] text-center text-xl font-black',
      highlight ? 'text-primary' : 'text-white/50'
    )}
  >
    {value ?? '–'}
  </span>
);

export default ScorePill;
